import styled from '@emotion/styled'
import { SKIP_DOLLAR_PROPS } from '@helpers/styles'
import MuiMenuItem from '@mui/material/MenuItem'

export const MenuItem = styled(MuiMenuItem, SKIP_DOLLAR_PROPS)<{
	$multiple?: boolean
}>`
	${({ $multiple, theme }) =>
		$multiple
			? `
	border-radius: 4px;
	display: flex;
	justify-content: space-between;
    margin: 3px;

	.Mui-selected {
		background: ${theme.palette.backgroundColors.lighterGrey};
	}
    `
			: ''}
`
